import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlagLanguagePipe } from '@ls-commons/utils/pipes';

@Component({
  selector: 'app-coverage-summary',
  standalone: true,
  imports: [CommonModule, FlagLanguagePipe],
  templateUrl: './coverage-summary.component.html',
  styleUrl: './coverage-summary.component.scss',
})
export class CoverageSummaryComponent {}
